/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const cart = {
  cartDetails: {
    id: 'Código',
    proceedToCheckout: 'Proceder al pago',
    cartName: 'Carrito #{{code}}',
  },
  cartItems: {
    id: 'Código',
    description: 'Descripción',
    item: 'Artículo',
    itemPrice: 'Precio del artículo',
    price: 'Precio',
    offer: 'Oferta',
    newPrice: 'Nuevo Precio €/TM (Descuento)',
    totalPrice: 'Precio total',
    unit: 'Unidad',
    width: 'Largo',
    numberOfSheets: 'Cant. de paquetes',
    quantityPaquete: 'Chapas / Paquete',
    quantityTubos: 'Tubos por paquete',
    weight: 'Peso por paquete',
    totalWeight: 'Peso total',
    quantityTitle:
      'La cantidad representa el número total de este artículo en su carrito.',
    total: 'Total',
    actions: 'Acciones',
    cartTotal: 'Total del carrito ({{count}} artículo)',
    cartTotal_other: 'Total del carrito ({{count}} artículos)',
    itemRemoved: 'Se ha eliminado el elemento seleccionado. Se ha actualizado el total del carrito.',
    caption: 'Contenido de la cesta de la compra.',
    orderExpress: {
      title: 'Compra Express',
      important: 'Aproveche las ventajas de un proceso de compra más rápido:',
      topic1: 'Si tienes más de una dirección de entrega, ve a Mi Compañía / Direcciones y establece la Dirección Predeterminada.',
      topic2: 'Si solo tienes una dirección, el paso previo no es necesario. El método de envío será express.',
      topic3: 'Solo necesitas introducir el número de pedido a continuación, indicar que quieres esta opción y confirmar los datos de tu pedido en el Checkout.',
      agree: 'Validar para Continuar con la Compra Express',
      checkout: 'Checkout',
      orderNumber: 'Numero do pedido'
    },
    lowNumberOfSheets: 'No es posible comprar esta cantidad, el peso del paquete es inferior al mínimo permitido de {{weight}} kg',
    packageWeightExceeded: 'No es posible comprar esta cantidad, el peso del paquete supera el máximo permitido de {{weight}} kg'
  },
  orderCost: {
    orderSummary: 'Resumen del pedido',
    totalWeight: 'Peso total:',
    subtotal: 'Subtotal después de descuentos:',
    shipping: 'Envío:',
    estimatedShipping: 'Envío estimado:',
    discount: 'Descuentos del Pedido:',
    salesTax: 'Impuesto sobre las ventas:',
    grossTax: 'El total del pedido no incluye los impuestos de',
    grossIncludeTax: 'El total del pedido incluye impuestos de',
    value: 'Importe:',
    total: 'Importe Total:',
    toBeDetermined: 'TBD',
    taxWarn: 'Impuestos no incluidos',
    weight: 'Peso Total:'
  },
  voucher: {
    coupon: '¿Tienes un cupón?',
    coupon_other: 'Códigos de cupón',
    couponLabel: 'Introduce un código promocional aquí',
    addCoupon: "Añadir cupón",
    apply: 'Aplicar',
    placeholder: 'Código promocional',
    applyVoucherSuccess: '{{voucherCode}} se ha aplicado.',
    removeVoucherSuccess: '{{voucherCode}} se ha eliminado.',
    anchorLabel: 'Ingresa o elimina tu código de cupón',
    vouchersApplied: 'Cupones aplicados',
    availableCoupons: 'Cupones disponibles',
    availableCouponsLabel: 'Puedes añadir estos cupones a este pedido.',
  },
  saveForLaterItems: {
    itemTotal: 'Guardado para más tarde ({{count}} elemento)',
    itemTotal_other: 'Guardado para más tarde ({{count}} elementos)',
    cartTitle: 'Carro',
    saveForLater: 'Guardar para más tarde',
    moveToCart: 'Mudarse a Carro',
    stock: 'Acción',
    forceInStock: 'In Acción',
  },
  clearCart: {
    clearCart: 'Despejar Carro',
    clearingCart: 'Despejando Carro...',
    cartClearedSuccessfully: 'El carrito activo se ha borrado correctamente.',
    areYouSureToClearCart: 'Está seguro de que quiere vaciar el carrito?',
    allItemsWillBeRemoved: 'Se eliminarán todos los artículos de su carrito activo.',
  },
  validation: {
    cartEntriesChangeDuringCheckout:
      'Durante el proceso de pago, encontramos problemas con sus entradas. Por favor, revise su carrito.',
    cartEntryRemoved:
      '{{name}} se eliminó del carrito debido a que estaba agotado.',
    productOutOfStock:
      '{{name}} ha sido eliminado del carrito debido a que no hay existencias suficientes.',
    lowStock: 'La cantidad se ha reducido a {{quantity}} debido a la falta de existencias.',
    reviewConfiguration:
      'Resuelva primero los problemas en la configuración para la entrada del carrito.',
    configurationError:
      'Resuelva primero los problemas en la configuración de las entradas del carrito.',
    pricingError:
      'La configuración de precios no está disponible actualmente. No es posible realizar la compra o enviar una cotización. Por favor, inténtelo de nuevo más tarde.',
    unresolvableIssues:
      'La configuración del producto requiere entradas adicionales en el back-end. Como resultado, no puede continuar. Póngase en contacto con el servicio de asistencia.',
    inProgress: 'Tratamiento',
  },
};
